import type { ITracingProvider, SpanContext, RumMetrics, FinishedSpan } from './types';

const isDev = (import.meta as any).env?.DEV;
const MAX_HISTORY = 100;

function rid() {
  return Math.random().toString(36).slice(2, 10);
}

export class NoopProvider implements ITracingProvider {
  private history: FinishedSpan[] = [];
  private errorCount = 0;

  startSpan(name: string, tags: Record<string, string> = {}): SpanContext {
    return { id: rid(), name, startTime: performance.now(), tags };
  }

  finishSpan(ctx: SpanContext, error?: Error): void {
    const finished: FinishedSpan = {
      id: ctx.id,
      name: ctx.name,
      durationMs: Math.max(0, performance.now() - ctx.startTime),
      tags: ctx.tags,
      status: error ? 'error' : 'ok',
      finishedAt: Date.now(),
    };
    this.history.unshift(finished);
    if (this.history.length > MAX_HISTORY) this.history.length = MAX_HISTORY;
  }

  recordError(error: Error, context?: Record<string, unknown>): void {
    this.errorCount++;
    if (isDev) console.error('[apm:noop] error', error, context);
  }

  setUser(_userId: string): void {
    /* no-op */
  }

  getRumMetrics(): RumMetrics {
    return {
      lcp: 1240,
      fid: 18,
      cls: 0.05,
      ttfb: 180,
      errorCount: 2 + this.errorCount,
      sessionCount: 47,
    };
  }

  getSpanHistory(): FinishedSpan[] {
    return [...this.history];
  }
}
